export const searchListsQuery = `query searchList($page: Int, $limit: Int, $filter: SearchFilterInput, $resourceType: String) {
  lists(page: $page, limit: $limit, filter: $filter, resourceType: $resourceType) {
      items {
        id
        name
        isDynamic
        active
        updatedAt
        owner {
          id
          firstname
          lastname
        }
        type {
          id
          name
          group
        }
        subscriptions {
          id
          active
          schedules {
            id
            active
            timezone
            interval
            time  
            dayOfWeek
            weekNumber
            endDate
          }
        }
        contents {
          id
          type
          description
        }
      }
      total
      page
      limit
    }
  }
  `;
  
  export const searchListQuery = `query getList($listId: Float!) {
    list(id: $listId) {
      id
      name
      isDynamic
      active
      updatedAt
      owner {
        id
        firstname
        lastname
      }
      type {
        id
        name
        group
      }
      subscriptions {
        id
        active
        schedules {
          id
          active
          timezone
          interval
          time  
          dayOfWeek
          weekNumber
          endDate
        }
      }
      contents {
        id
        type
        description
      }
    }
  }
  `;
  
  export const deleteListQuery = `mutation ($listId: Float!) {
    deleteList(listId: $listId ) {
      success
    }
  }`;
  
  export const UnsubscribeListQuery = `mutation ($listId: Float!, $userEmail: String!) {
    unsubscribeFromList(listId: $listId, userEmail: $userEmail) {
      success
    }
  }`;
